/**
 * 语言包导出
 */

import type { Locale, TranslationDict } from "../types";
import { en } from "./en";
import { zhCN } from "./zh-CN";

/**
 * 所有语言包的映射
 */
export const locales: Record<Locale, TranslationDict> = {
  "zh-CN": zhCN,
  en: en,
};
